import { StarIcon } from './icons'

interface MatchOdds {
	label: string
	value: string
}

export interface Match {
	league: string
	country: string
	teamA: { name: string; image: string }
	teamB: { name: string; image: string }
	odds: [MatchOdds, MatchOdds, MatchOdds] | [MatchOdds, MatchOdds]
	banner: string
}

export function MatchCard({ match }: { match: Match }) {
	return (
		<div className='flex w-[280px] shrink-0 flex-col overflow-hidden rounded-2xl border border-border bg-card sm:w-[369px]'>
			<div className='relative h-[54px] shrink-0'>
				<img src={match.banner} alt='' className='absolute inset-0 h-full w-full object-cover opacity-40' />
				<div className='relative flex h-full items-center justify-center gap-2 px-4 text-sm font-semibold tracking-[-0.21px] text-foreground'>
					<StarIcon className='h-4 w-4 shrink-0 text-subtle-foreground' />
					{match.country}
				</div>
				<div className='px-4 pb-1 text-center text-xs text-subtle-foreground'>{match.league}</div>
			</div>

			<div className='flex items-center justify-center gap-4 px-4 py-5'>
				<div className='flex flex-1 flex-col items-center gap-1.5'>
					<img src={match.teamA.image} alt='' className='h-10 w-10 rounded-full object-cover' />
					<span className='line-clamp-1 text-center text-sm text-foreground'>{match.teamA.name}</span>
				</div>
				<span className='text-lg font-bold tracking-tight text-foreground'>VS</span>
				<div className='flex flex-1 flex-col items-center gap-1.5'>
					<img src={match.teamB.image} alt='' className='h-10 w-10 rounded-full object-cover' />
					<span className='line-clamp-1 text-center text-sm text-foreground'>{match.teamB.name}</span>
				</div>
			</div>

			<div className='flex gap-1 px-2 pb-3'>
				{match.odds.map((odd) => (
					<div key={odd.label} className='flex flex-1 items-center justify-between rounded-lg bg-secondary px-3 py-1.5'>
						<span className='text-sm text-subtle-foreground'>{odd.label}</span>
						<span className='text-sm font-medium text-foreground'>{odd.value}</span>
					</div>
				))}
			</div>
		</div>
	)
}
